import { render, staticRenderFns } from "./CommunicationDetails.vue?vue&type=template&id=be983af6&scoped=true&"
import script from "./CommunicationDetails.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be983af6",
  null
  
)

export default component.exports